import { jsx as _jsx } from "react/jsx-runtime";
import { useStyleConfig, vui } from '../core';
import Divider from '../divider';
import { cs } from '../utils';
import { useHeaderContext } from './context';
/** Vertical line dividing part of the Header content. */
export const HeaderDivider = vui((props, ref) => {
    const { className, ...rest } = props;
    const styles = useStyleConfig('Header', useHeaderContext());
    return (_jsx(Divider, { borderColor: "darkBlue.main", className: cs('vui-headerDivider', className), h: 40, isVertical: true, ref: ref, ...styles.divider, ...rest }));
});
HeaderDivider.displayName = 'HeaderDivider';
export default HeaderDivider;
